import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatTooltipModule } from '@angular/material/tooltip';

import { DownloadLinkComponent } from './download-link.component';
import { NgLetModule } from '@shared/directives/ng-let/ng-let.module';
import { SvgModule } from '@shared/components/svg/svg.module';

@NgModule({
  declarations: [DownloadLinkComponent],
  imports: [
    CommonModule,
    NgLetModule,
    MatTooltipModule,
    SvgModule,
  ],
  exports: [DownloadLinkComponent],
})
export class DownloadLinkModule {}
